module.exports = __webpack_public_path__ + "img/portraits_04_V.2799fea0.jpg";